import { createContext, ReactNode, useContext } from 'react';

import type { PipelineCard } from '@/pages/pipelines/common/types';

type CardAccessoryRenderer = (_card: PipelineCard) => ReactNode;

const CardAccessoryContext = createContext<CardAccessoryRenderer | null>(null);

/**
 * Lets a board owner mount its own interactive control on every card without threading a render
 * prop through the column/drag layers. Boards that do not provide one render no accessory.
 */
export const PipelineCardAccessoryProvider = ({
  render,
  children,
}: {
  render: CardAccessoryRenderer;
  children: ReactNode;
}) => <CardAccessoryContext.Provider value={render}>{children}</CardAccessoryContext.Provider>;

export const usePipelineCardAccessory = (): CardAccessoryRenderer | null =>
  useContext(CardAccessoryContext);
